import IconButton from "@mui/material/IconButton";

import {BmCloseIcon, BmAlertIcon} from "~/components/icons/simpleIcons";
import {designColors} from "~/ui";
import {BmBaseInfoBanner, BmBaseInfoBannerProps, commonStyles} from "~/components/banners";

export interface BmWarningNotificationBannerProps
  extends Omit<BmBaseInfoBannerProps, "bodySx" | "colorPreset" | "leftColumn" | "rightColumn"> {
  closeButton?: boolean;
  onClose?: VoidFunction;
}

export const BmWarningNotificationBanner: React.FC<BmWarningNotificationBannerProps> = ({
  closeButton,
  onClose,
  ...restProps
}) => {
  return (
    <BmBaseInfoBanner
      {...restProps}
      bodySx={{flexWrap: "nowrap"}}
      colorPreset="yellow"
      leftColumn={<BmAlertIcon id="alert-icon" className={commonStyles.icon} size="xs" />}
      rightColumn={
        closeButton ? (
          <IconButton onClick={onClose} disableRipple size="small">
            <BmCloseIcon id="close-icon" color={designColors.colorInk} />
          </IconButton>
        ) : undefined
      }
    />
  );
};
